import React from 'react';
import ReactDOM from 'react-dom';
import { PiXBold } from 'react-icons/pi';

export default function Modal({
    open,
    onClose,
    children,
    maxWidth = 'max-w-2xl',
    className = '',
    showClose = true,
}) {
    if (!open) return null;

    const portalRoot = document.getElementById('portal') || document.body;

    const handleBackdropClick = (event) => {
        if (showClose && event.target === event.currentTarget) {
            onClose?.();
        }
    };

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm sm:p-6 lg:p-8"
            onClick={handleBackdropClick}
        >
            {showClose && (
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Ablak bezárása"
                    title="Bezárás"
                    className="group absolute right-4 top-4 z-20 flex size-12 items-center justify-center overflow-hidden rounded-2xl border border-white/30 bg-white/15 text-white shadow-2xl backdrop-blur-xl transition hover:scale-105 hover:border-white/60 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/40 active:scale-95 sm:right-6 sm:top-6 sm:size-14"
                >
                    <span className="absolute inset-0 bg-gradient-to-br from-sky-400/50 via-lime-400/40 to-orange-400/60 opacity-60 transition group-hover:opacity-100" />
                    <PiXBold className="relative size-5 drop-shadow sm:size-6" />
                </button>
            )}

            <div
                role="dialog"
                aria-modal="true"
                className={`modal-scrollbar relative max-h-[calc(100dvh-2rem)] w-full ${maxWidth} overflow-x-hidden overflow-y-auto rounded-3xl gradient-gray text-white shadow-2xl ring-8 ring-white/20 sm:max-h-[calc(100dvh-3rem)] ${className}`}
            >

                <div className="absolute inset-0 bg-gradient-to-br from-white/25 via-white/5 to-transparent pointer-events-none" />
                <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none" />

                <div className="flex flex-col gap-4 relative z-10 text-white">
                    {children}
                </div>
            </div>
        </div>,

        portalRoot
    );
}
